import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../../config/authAxios"




const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getBankDetailsAction = createAsyncThunk(
    'get-all-banks',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.get(`/support-server/api/all-publisher-bank-details`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getBankDetailsSlice = createSlice({
    name: 'get-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getBankDetailsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getBankDetailsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getBankDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getBankDetailsReducer = getBankDetailsSlice.reducer